import { UserRole } from "../ConfigContext/types";

export interface BaseUser {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  adObjectId?: string;
}

export enum GlobalUserRole {
  ADMIN = "Admin",
  READER = "Reader",
}

export interface ClientAccess {
  id: number;
  clientId: number;
  clientName: string;
  role: UserRole;
}

export interface UserWithClients extends BaseUser {
  globalRole: GlobalUserRole;
  clientAccesses: ClientAccess[];
}
